<app-page-header [title]="'Media'" [subtitle]="'Manage media for SampleStudio'"></app-page-header>

<div class="flex flex-col gap-6 mb-6">
    <app-upload-media (uploadSuccess)="reloadMediaWithDelay()"
                      (uploadError)="reloadMediaWithDelay()"></app-upload-media>

    <div class="rounded">
        <p-dataView
            #mediaView
            [value]="media"
            [rows]="8"
            [paginator]="true"
            [first]="currentPage * 8"
            [lazy]="true"
            [sortField]="sortKey"
            [sortOrder]="sortOrder"
            [totalRecords]="totalElements"
            [layout]="layout"
            (onLazyLoad)="onPageChange($event)"
        >

            <!-- Header with Sorting and View Switch -->
            <ng-template #header>
                <div class="flex flex-col md:flex-row md:justify-between">
                    <div class="flex gap-2">
                        <!-- Search Input -->
                        <p-ifta-label>
                            <p-iconfield>
                                <p-inputicon class="pi pi-search"></p-inputicon>
                                <input
                                        pInputText
                                        id="media_search"
                                        [(ngModel)]="search"
                                        (input)="onSearchInputChange()"
                                        autocomplete="off"
                                />
                            </p-iconfield>
                            <label for="media_search">Search media</label>
                        </p-ifta-label>
                        <!-- Sorting Dropdown -->
                        <p-ifta-label class="w-full md:w-56">
                            <p-select
                                    id="sort"
                                    [(ngModel)]="sortKey"
                                    [options]="sortOptions"
                                    placeholder="Sort By"
                                    (onChange)="onSortChange($event)"
                                    styleClass="mb-2 md:mb-0">
                            </p-select>
                            <label for="sort">Sort By</label>
                        </p-ifta-label>

                    </div>


                    <!-- Layout Toggle -->
                    <p-select-button
                            [(ngModel)]="layout"
                            [options]="layoutOptions"
                            [allowEmpty]="false">
                        <ng-template #item let-item>
                            <i class="pi" [ngClass]="{ 'pi-bars': item === 'list', 'pi-table': item === 'grid' }"></i>
                        </ng-template>
                    </p-select-button>
                </div>
            </ng-template>

            <!-- List Layout -->
            <ng-template #list let-items>
                <div class="grid grid-cols-12 gap-4 grid-nogutter">
                    @for (media of items; track media; let first = $first) {
                        <div class="col-span-12">
                            <div
                                    [ngClass]="{ 'border-t border-gray-300 dark:border-gray-700': !first }"
                                    class="flex flex-col sm:flex-row sm:items-center p-6 gap-4">
                                <div class="md:w-20 relative">
                                    <img
                                            [alt]="media.filename"
                                            [src]="media.content.cloudfrontUrl"
                                            class="block mx-auto w-full h-auto object-contain"
                                    />
                                </div>
                                <div class="flex flex-col md:flex-row justify-between md:items-center flex-1 gap-6">
                                    <div class="text-lg font-medium text-surface-900 dark:text-surface-0 mt-2">
                                        {{ media.filename }}
                                    </div>
                                    <div class="flex flex-col md:items-end gap-8">
                                        <div class="flex gap-2">
                                            <p-button (click)="openReplaceDialog(media)" icon="pi pi-image"
                                                      text></p-button>
                                            <p-button (click)="openEditDialog(media)" icon="pi pi-pencil"
                                                      isMaintainer
                                                      text></p-button>
                                            <p-button (click)="openDeleteDialog(media)" icon="pi pi-trash"
                                                      isMaintainer
                                                      severity="danger"
                                                      text></p-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </ng-template>

            <!-- Grid Layout -->
            <ng-template #grid let-items>
                <div class="grid grid-cols-12 gap-1">
                    @for (media of items; track media) {
                        <div
                                class="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3 p-2">
                            <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md flex justify-between flex-col h-full">
                                <div class="bg-surface-50 flex justify-center rounded p-1">
                                    <img
                                            [alt]="media.filename"
                                            [src]="media.content.cloudfrontUrl"
                                            class="rounded w-full h-auto max-h-96 object-contain"
                                    />
                                </div>
                                <div class="pt-6">
                                    <div class="text-lg font-medium mt-1 overflow-hidden">{{ media.filename }}</div>
                                    <div class="flex flex-col gap-6 mt-6">
                                        <div class="flex gap-2">
                                            <p-button (click)="openReplaceDialog(media)" icon="pi pi-image"
                                                      text></p-button>
                                            <p-button (click)="openEditDialog(media)" icon="pi pi-pencil"
                                                      isMaintainer
                                                      text></p-button>
                                            <p-button (click)="openDeleteDialog(media)" icon="pi pi-trash"
                                                      isMaintainer
                                                      severity="danger"
                                                      text></p-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </ng-template>
        </p-dataView>
    </div>

    <!-- Update Media Dialog -->
    <app-update-media-dialog
            [(visible)]="editDialogVisible"
            [media]="selectedMedia"
            (mediaUpdated)="loadMedia()"
    ></app-update-media-dialog>

    <app-replace-file-dialog
            [(visible)]="replaceDialogVisible"
            [media]="selectedMedia"
            (mediaReplaced)="loadMedia()"
    ></app-replace-file-dialog>

</div>
